module.exports = __webpack_public_path__ + "img/partner17.ccc65685.png";